// extracted by mini-css-extract-plugin
export var defaultWrapper = "_gt-3";
export var downloadButton = "_gt-4";
export var fileContainer = "_gt-9 _gt-7";
export var fileContainerBase = "_gt-7";
export var fileContainerBaseSm = "_gt-a _gt-7";
export var fileContainerFixedHeight = "_gt-8 _gt-7";
export var fileContainerFixedHeightSm = "_gt-c _gt-a _gt-7";
export var fileContainerSm = "_gt-b _gt-a _gt-7";
export var fileInfo = "_gt-5";
export var fileInfoWidthRestricted = "_gt-6";
export var fileType = "_gt-1";
export var fileTypeName = "_gt-2";
export var fileTypeSm = "_gt-d _gt-1";
export var image = "_gt-0";
export var link = "_gt-f";
export var overflowEllipsis = "_gt-e";